module.exports = __webpack_public_path__ + "images/ff12cb327152f2b424b7bb4c71dc606a-icons.svg";